import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {
    myForm: FormGroup;
    iframeSrc: string;

    @ViewChild('iframe') iframe: ElementRef;

    constructor(private http: HttpClient, private fb: FormBuilder) {
        this.myForm = this.fb.group({
            // Define your form controls here
        });
    }

    ngOnInit() { }

    onSubmit() {
        // Assuming your backend endpoint to get subscription details is at 'http://localhost:yourport/api/razorpay/getsubscriptiondetails'
        this.http.get<any>('http://localhost:yourport/api/razorpay/getsubscriptiondetails')
            .subscribe(
                (response) => {
                    // Extract the short URL from the response
                    const shortUrl = response.short_url;

                    // Set iframe source to the short URL
                    this.iframeSrc = shortUrl;
                },
                (error: HttpErrorResponse) => {
                    console.error('Error fetching subscription details:', error);
                    // Handle error as needed
                }
            );
    }
}
